import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\Tools\Mediaclip\MediaclipProductToolConfiguratorController::__invoke
* @see Http/Controllers/Web/Tools/Mediaclip/MediaclipProductToolConfiguratorController.php:28
* @route '/tools/{configurableProduct}/mediaclip/configurator/{mediaclipProjectId}'
*/
const MediaclipProductToolConfiguratorController = (args: { configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number } | [configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: MediaclipProductToolConfiguratorController.url(args, options),
    method: 'get',
})

MediaclipProductToolConfiguratorController.definition = {
    methods: ["get","head"],
    url: '/tools/{configurableProduct}/mediaclip/configurator/{mediaclipProjectId}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\Tools\Mediaclip\MediaclipProductToolConfiguratorController::__invoke
* @see Http/Controllers/Web/Tools/Mediaclip/MediaclipProductToolConfiguratorController.php:28
* @route '/tools/{configurableProduct}/mediaclip/configurator/{mediaclipProjectId}'
*/
MediaclipProductToolConfiguratorController.url = (args: { configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number } | [configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            configurableProduct: args[0],
            mediaclipProjectId: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        configurableProduct: typeof args.configurableProduct === 'object'
        ? args.configurableProduct.url_key
        : args.configurableProduct,
        mediaclipProjectId: args.mediaclipProjectId,
    }

    return MediaclipProductToolConfiguratorController.definition.url
            .replace('{configurableProduct}', parsedArgs.configurableProduct.toString())
            .replace('{mediaclipProjectId}', parsedArgs.mediaclipProjectId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Tools\Mediaclip\MediaclipProductToolConfiguratorController::__invoke
* @see Http/Controllers/Web/Tools/Mediaclip/MediaclipProductToolConfiguratorController.php:28
* @route '/tools/{configurableProduct}/mediaclip/configurator/{mediaclipProjectId}'
*/
MediaclipProductToolConfiguratorController.get = (args: { configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number } | [configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: MediaclipProductToolConfiguratorController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Tools\Mediaclip\MediaclipProductToolConfiguratorController::__invoke
* @see Http/Controllers/Web/Tools/Mediaclip/MediaclipProductToolConfiguratorController.php:28
* @route '/tools/{configurableProduct}/mediaclip/configurator/{mediaclipProjectId}'
*/
MediaclipProductToolConfiguratorController.head = (args: { configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number } | [configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: MediaclipProductToolConfiguratorController.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\Tools\Mediaclip\MediaclipProductToolConfiguratorController::__invoke
* @see Http/Controllers/Web/Tools/Mediaclip/MediaclipProductToolConfiguratorController.php:28
* @route '/tools/{configurableProduct}/mediaclip/configurator/{mediaclipProjectId}'
*/
const MediaclipProductToolConfiguratorControllerForm = (args: { configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number } | [configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: MediaclipProductToolConfiguratorController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Tools\Mediaclip\MediaclipProductToolConfiguratorController::__invoke
* @see Http/Controllers/Web/Tools/Mediaclip/MediaclipProductToolConfiguratorController.php:28
* @route '/tools/{configurableProduct}/mediaclip/configurator/{mediaclipProjectId}'
*/
MediaclipProductToolConfiguratorControllerForm.get = (args: { configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number } | [configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: MediaclipProductToolConfiguratorController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Tools\Mediaclip\MediaclipProductToolConfiguratorController::__invoke
* @see Http/Controllers/Web/Tools/Mediaclip/MediaclipProductToolConfiguratorController.php:28
* @route '/tools/{configurableProduct}/mediaclip/configurator/{mediaclipProjectId}'
*/
MediaclipProductToolConfiguratorControllerForm.head = (args: { configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number } | [configurableProduct: string | number | { url_key: string | number }, mediaclipProjectId: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: MediaclipProductToolConfiguratorController.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

MediaclipProductToolConfiguratorController.form = MediaclipProductToolConfiguratorControllerForm

export default MediaclipProductToolConfiguratorController